import { useEnsAvatar, useEnsName } from 'wagmi';

export const useEnsAvatarLookup = (address: string) => {
  const { data: ensName } = useEnsName({
    address: address as `0x${string}`,
    enabled: !!address,
  });

  const { data: ensAvatar } = useEnsAvatar({
    name: ensName ?? undefined,
    enabled: !!ensName,
  });

  return ensAvatar ?? undefined;
};
